<template>
  <section class="article-gallery">
    <div class="columns">
      <app-link
       class="column article-gallery__first-photo"
       :to="context.url"
       :routing-data="context.routing_data"
       :path-type="context.type"
      >
        <div class="hover-photo">
          <div class="hover-photo__more">
            <i class="icon-camera" />
            Zobacz zdjęcie
          </div>
        </div>
        <photo-loader
         :image="firstImage"
         height-skeletor="540"
         :altImg="firstImage?.alt"
         :imgWidth="firstImage?.width"
         :imgHeight="firstImage?.height"
        />
      </app-link>
    </div>
    <div class="columns article-gallery__other-photo">
      <div class="column">
        <div class="article-gallery__example">
          <app-link
           v-for="(item, key) in otherImage"
           :key="key"
           class="article-gallery__example--box"
           :to="`${context.url}?image=${item._id}`"
           :routing-data="context.routing_data"
           :path-type="context.type"
          >
            <photo-loader
             :image="item"
             height-skeletor="540"
             :altImg="item?.alt"
             :imgWidth="item?.width"
             :imgHeight="item?.height"
            />
          </app-link>
          <app-link
           class="article-gallery__example--box see-more"
           :to="context.url"
           :routing-data="context.routing_data"
           :path-type="context.type"
          >
            <span> zobacz <br />wszystkie</span>
          </app-link>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <figcaption>
          <div class="article__rectangle"></div>
          <div class="article__image-title">{{ context?.title }}</div>
        </figcaption>
      </div>
    </div>
  </section>
</template>

<script setup>
import PhotoLoader from "@/components/elements/PhotoLoader.vue";
import {computed} from "vue";
import AppLink from "@/components/layout/AppLink.vue";

const firstImage = computed(() => props.context?.images?.[0])
const otherImage = computed(() => props.context?.images?.slice(1, 4) ?? [])

const props = defineProps({
  context: {
    type: Object,
    default: () => ({})
  },
})
</script>

<style lang="scss">
@import '@/assets/scss/components/article/article-gallery.scss';
</style>
